 
 <template>
  <div class="home">
    <div class="wrapper-content registerHeader">
      <div class="breadcrumb_box">
        <div class="container-fluid">
          <h2>Pin Your Location</h2>
        </div>
      </div>

      <div class="addmoney newaddress">
        <div class="container">
          <div class="row">
            <div class="col-sm-12">
              <div class="add-newaddresss panel mapnewcustome">
                <div class="input-animation">
                  <div v-if="isSearch" class="searchbox">
                    <i class="fa fa-search"></i>
                    <gmap-autocomplete @place_changed="setPlace" class="mb-1"></gmap-autocomplete>
                    <b-button v-on:click="isSearch=false">
                      <i class="fa fa-close"></i>
                    </b-button>
                  </div>
                  <gmap-map :center="center" :zoom="12" style="width:100%;  height: 400px;">
                    <gmap-marker :position="center" @drag="updateCoordinates" :draggable="true"></gmap-marker>
                  </gmap-map>
                  <div class="input-field relateclass" v-b-modal.map>
                    <input type="text" id="local" disabled v-model="locality" />
                    <!-- <label for="local">Search Location</label> -->
                    <!-- <img class="svg" src="../assets/images/maps-and-flags.svg" alt="map" /> -->
                    <b-button v-on:click="isSearch=true">Change</b-button>
                  </div>
                </div>

                <button
                  class="submit-btn"
                  type="submit"
                  v-on:click="addNewAddress"
                  v-if="isNewAdd"
                >Submit</button>
                <button class="submit-btn" type="submit" v-on:click="getregistered" v-else>Submit</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { registerProfile, addAddress, checklatLong } from "./../services/api";
import VueGeolocation from "vue-browser-geolocation";
const axios = require("axios");
Vue.use(VueGeolocation);
export default {
  name: "home",
  data() {
    return {
      lat: "",
      long: "",
      address: "",
      addressTitle: "",
      key: "AIzaSyBmS9QQWofTpIbYDpWebbUP9lhbBBW5raA",
      name: "",
      email: "",
      locality: "",
      state: "",
      city: "",
      zipCode: "",
      houseNo: "",
      landmark: "",
      center: {
        lat: "",
        lng: ""
      },
      markers: [],
      places: [],
      currentPlace: null,
      isSearch: false,
      isNewAdd: this.$route.query.addNew
    };
  },

  created() {
    if (window.location.href.includes("edit-location")) {
      if (!localStorage.getItem("userName")) {
        localStorage.clear();
        this.$router.push({ name: "register" });
      } else {
        this.addLocation();
      }
    } else {
      this.geolocate();
    }
  },
  methods: {
    checkCustomerLatLong() {
      var requestData = {
        lat: 30.718606125937352,
        vendor_id: "2",
        lng: 76.72680370509624
      };
      checklatLong(requestData)
        .then(result => {
          if (result.data.successCode === 1) {
            console.log(result);
          } else if (
            (result.data.successCode === 0 &&
              result.data.messageCode === 1053) ||
            result.data.messageCode == 201
          ) {
            localStorage.clear();
            this.$router.replace({ name: "register" });
            this.isLoading = false;
          }
        })
        .catch(error => {
          // this.isLoading = false;
          return;
        });
    },
    addLocation() {
      var getAddress = JSON.parse(localStorage.getItem("address"));

      this.center = {
        lat: JSON.parse(getAddress.lat),
        lng: JSON.parse(getAddress.long)
      };

      this.getStreetAddressFrom(getAddress.lat, getAddress.long);
    },
    updateCoordinates(location) {
      this.lat = location.latLng.lat();
      this.long = location.latLng.lng();

      this.getStreetAddressFrom(this.lat, this.long);
    },
    setPlace(place) {
      console.log("$$$", place);
      this.currentPlace = place;
      this.addMarker();
    },
    addMarker() {
      if (this.currentPlace) {
        const marker = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng()
        };
        this.markers.push({ position: marker });
        this.places.push(this.currentPlace);
        this.center = marker;
        this.currentPlace = null;
      }
    },

    geolocate: function() {
      navigator.geolocation.getCurrentPosition(position => {
        if (position.coords.latitude) {
          this.center = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
          this.getStreetAddressFrom(
            position.coords.latitude,
            position.coords.longitude
          );
        } else {
          this.center = {
            lat: 30.679948,
            lng: 76.726951
          };
        }
      });
    },

    async getStreetAddressFrom(lat, long) {
      try {
        var { data } = await axios.get(
          "https://maps.googleapis.com/maps/api/geocode/json?latlng=" +
            lat +
            "," +
            long +
            "&key=" +
            this.key
        );

        if (data.error_message) {
        } else {
          this.locality = data.results[0].formatted_address;

          for (var i = 0; i < data.results[0].address_components.length; i++) {
            for (
              var b = 0;
              b < data.results[0].address_components[i].types.length;
              b++
            ) {
              if (
                data.results[0].address_components[i].types[b] ==
                "administrative_area_level_1"
              ) {
                this.state = data.results[0].address_components[i].long_name;

                break;
              }

              if (
                data.results[0].address_components[i].types[b] ==
                "administrative_area_level_2"
              ) {
                this.city = data.results[0].address_components[i].long_name;

                break;
              }
              if (
                data.results[0].address_components[i].types[b] == "postal_code"
              ) {
                this.zipCode = data.results[0].address_components[i].long_name;

                break;
              }
              if (
                data.results[0].address_components[i].types[b] ==
                "street_number"
              ) {
                this.houseNo = data.results[0].address_components[i].long_name;

                break;
              }
            }
          }
        }
      } catch (error) {}
    },
    addNewAddress() {
      var getAddress = JSON.parse(localStorage.getItem("newAddress"));
      var latitude = "";
      var longitude = "";
      if (!this.lat && !this.long) {
        latitude = this.center.lat;
        longitude = this.center.lng;
      } else {
        latitude = this.lat;
        longitude = this.long;
      }
      var requestData = {
        user_id: localStorage.getItem("userId"),
        token: localStorage.getItem("token"),
        address: getAddress.address,
        city: getAddress.city,
        state: getAddress.state,
        areaCode: this.zipCode,
        landMark: getAddress.landMark,
        title: getAddress.title,
        vendor_id: localStorage.getItem("vendorId"),
        locality: "",
        area_id: 1126,
        location: this.locality,
        lat: latitude,
        lng: longitude
      };
      // var requestData = {
      //   user_id: localStorage.getItem("userId"),
      //   token: localStorage.getItem("token"),
      //   area_id: 0,
      //   region_id: 0,

      //   address: getAddress.address,
      //   image: getAddress.image,
      //   location: this.locality,
      //   lat: latitude,
      //   lng: longitude,
      //   landMark: getAddress.landMark,
      //   areaCode: this.zipCode,
      //   state: getAddress.state,
      //   title: getAddress.title,
      //   city: getAddress.city,
      //   vendor_id: localStorage.getItem("vendorId")
      // };
      console.log(requestData);
      addAddress(requestData)
        .then(result => {
          if (result.data.successCode === 1) {
            localStorage.removeItem("newAddress");

            this.$router.push("/");
          } else if (
            result.data.successCode === 0 &&
            result.data.messageCode === 1053
          ) {
            localStorage.clear();
            this.$router.replace({ name: "register" });
          }
        })
        .catch(error => {
          return;
        });
    },
    getregistered() {
      var getAddress = JSON.parse(localStorage.getItem("address"));
      var latitude = "";
      var longitude = "";
      if (!this.lat && !this.long) {
        latitude = this.center.lat;
        longitude = this.center.lng;
      } else {
        latitude = this.lat;
        longitude = this.long;
      }

      var requestData = {
        user_id: localStorage.getItem("userId"),
        token: localStorage.getItem("token"),
        area_id: 0,
        region_id: 0,
        name: getAddress.name,
        email: getAddress.email,
        address: getAddress.address,
        image: getAddress.image,
        location: this.locality,
        lat: latitude,
        lng: longitude,
        landMark: getAddress.landMark,
        areaCode: this.zipCode,
        state: getAddress.state,
        title: getAddress.title,
        city: getAddress.city,
        vendor_id: localStorage.getItem("vendorId")
      };
      console.log(requestData);
      registerProfile(requestData)
        .then(result => {
          if (result.data.successCode === 1) {
            localStorage.removeItem("address");
            if (window.location.href.includes("edit-location")) {
              this.$router.push("profile");
            } else {
              this.$router.push("/");
              localStorage.setItem("userName", requestData.name);
            }
          } else if (
            result.data.successCode === 0 &&
            result.data.messageCode === 1053
          ) {
            localStorage.clear();
            this.$router.replace({ name: "register" });
          }
        })
        .catch(error => {
          return;
        });
    }
  }
};
</script>
<style lang="scss">
@import "../assets/css/custom.scss";
</style>